import { createConsumer } from "@rails/actioncable"

let consumer = null

function getConsumer() {
  if (!consumer) consumer = createConsumer()
  return consumer
}

function createSubscription(identifier, callbacks = {}) {
  const subscription = getConsumer().subscriptions.create(identifier, {
    connected() {
      callbacks.connected?.()
    },
    disconnected() {
      callbacks.disconnected?.()
    },
    rejected() {
      callbacks.rejected?.()
    },
    received(data) {
      callbacks.received?.(data)
    },
  })

  return () => subscription.unsubscribe()
}

export function subscribeToQuestionForecastStatus(questionId, callbacks) {
  return createSubscription({ channel: "QuestionForecastStatusChannel", question_id: questionId }, callbacks)
}

export function subscribeToBalanceTopUpStatus(topUpId, callbacks) {
  return createSubscription({ channel: "BalanceTopUpStatusChannel", top_up_id: topUpId }, callbacks)
}
